import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { convertLocalToUtcDate, formatDateTime } from 'library/time';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Transfer } from 'components/Page';
import CompetencyUserFormInput from './bulkinput';
import config from './config';

const mapStateToProps = state => ({
  competency: state.api.competency.data,
  inFlight: state.api.competency.inFlight
});

const CompetencyUsers = ({
  competency, inFlight, objectId, permissions
}) => {
  let form = null;
  // if record is localy managed and the user has permissions
  const canAdmin = !competency.is_integration_managed && permissions.CanAdminCompetencies()
    .hasPermissions();
  /**
   * @description Get the User Competency From reference
   * @param inputForm object
   */
  const getUserCompetencyFormRef = (inputForm) => {
    form = inputForm || form; // refresh the form or assign the form;
  };

  /**
   * @description Merge Users with Competency Details
   * @param users array
   * @returns object
   */
  const handleAssignData = (users) => {
    const {
      assessor, auto_expire, scheduled, awarded_date, expiry_date
    } = form.props.dataSource;
    return {
      users,
      assessor,
      auto_expire,
      scheduled: scheduled ? formatDateTime(convertLocalToUtcDate(scheduled)) : null,
      awarded_date: awarded_date ? formatDateTime(convertLocalToUtcDate(awarded_date)) : null,
      expiry_date: expiry_date ? formatDateTime(convertLocalToUtcDate(expiry_date)) : null
    };
  };

  /**
   * @description Validate the form input and return whether and error exists or not
   * @returns bool
   */
  const handleFormValidate = () => {
    let isError = false;
    form.props.form.validateFields((error) => {
      isError = error;
    });
    return !isError;
  };

  return (
    <Transfer
      canAdmin={canAdmin}
      reducer={{
        destination: REDUCER_KEY.assignedCompetencyUsers,
        source: REDUCER_KEY.unAssignedCompetencyUsers
      }}
      objectId={objectId} // the parent object
      config={{
        ...config,
        // Table ToolBar Buttons
        commands: {
          disableAdd: !canAdmin,
          disableRemove: true
        },
        // override source table config with current data
        source: {
          ...config.source,
          // record filter for unassigned users
          filters: {
            competency_id__ne: [objectId]
          },
          // Table row config
          rowSelectionConfig: {
            ...config.source.rowSelectionConfig,
            selectItemOnSingleClick: false,
            highlightRow: canAdmin
          }
        },
        // override destination table config with current data
        destination: {
          ...config.destination,
          // record filter for assigned users
          filters: {
            competency_id: [objectId]
          }
        }
      }}
      // Provide the Transfer an interceptor to do somethign with the data before processing it
      interceptor={{
        title: 'Enter the Competency Details',
        width: 800,
        component: props => (
          <CompetencyUserFormInput
            {...props}
            canAdmin={canAdmin}
            // turn off default buttons to hand control to Modal
            commands={{
              showSaveButton: false,
              showCancelButton: false
            }}
            // provide competency object
            competency={competency}
            inFlight={inFlight}
            title="Competency Details"
            checkboxFormItemLayout={{
              wrapperCol: {
                sm: {
                  span: 24,
                  offset: 0
                }
              }
            }}
            wrappedComponentRef={getUserCompetencyFormRef}
          />
        )
      }}
      onInterceptorOk={handleFormValidate}
      onPrepareSourceData={handleAssignData}
      permissions={permissions}
    />
  );
};

CompetencyUsers.propTypes = {
  competency: PropTypes.object,
  inFlight: PropTypes.bool,
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

CompetencyUsers.defaultProps = {
  competency: {},
  inFlight: false,
  objectId: null
};

export default connect(mapStateToProps, null)(CompetencyUsers);
